import DashboardRoute from "./dashboard/Dashboard.Route";
import MasterRoute from './master/MasterRoute';
import SettingsRoute from './settings/SettingsRoute';
import UsersRoute from './users/UsersRoute';
import MaintenanceRoute from './maintenance/MaintenanceRoute';
import InventoryRoute from './inventory/InventoryRoute';
import DocRoute from './doc/DocRoute';
import ReportRoute from './report/ReportRoute';

const PrivateRoute = () => {
    return [
        ...DashboardRoute(),
        ...MasterRoute(),
        ...SettingsRoute(),
        ...UsersRoute(),
        ...MaintenanceRoute(),
        ...InventoryRoute(),
        ...DocRoute(),
        ...ReportRoute(),
    ]
}

export default PrivateRoute